const COLORS = [
  '#B3DDFF',
  '#96C9E7',
  '#80B2D9',
  '#6993C6',
  '#C1D2FF',
  '#A0B3FF',
  '#9399FF',
  '#9380E5',
  '#ECD5E1',
  '#DDBFCE',
  '#DBAEB9',
  '#C58D8E',
  '#BECD80',
  '#B0C780',
  '#B3CB5D',
  '#A5B851',
  '#CBD9BA',
  '#B5CDA2',
  '#8FB88E',
  '#79A384',
  '#E2E585',
  '#E2CD82',
  '#E2B880',
  '#FFB258',
];

export default COLORS;
